import Enum from "../../../enums/Enum";

const EnumRestrictionReason = new Enum({
    ABUSIVE_OR_AGGRESSIVE: "Patient is Abusive/Aggressive",
    BOUNDARY_BREACHED: "Professional boundary has been breached",
    BLOCKED: "Restricted from Bookings"
});

export default EnumRestrictionReason;